import { servicePost } from "./client.ts";

export interface ReplenishOrderItem {
  ID: number;
  ReplenishOrderID: number;
  ProductID: number;
  ToStock: number;
  Stocked: number | null;
  Name: string;
  Finished: string | null;
  Deleted: string | null;
}

export interface ReplenishOrder {
  ID: number;
  Identifier: string;
  KioskID: number;
  OperatorID: number;
  Note: string;
  FinishedBy: number | null;
  Finished: string | null;
  Created: string | null;
  Deleted: string | null;
  Items: ReplenishOrderItem[];
}

export function getReplenishOrder(id: number) {
  return servicePost<ReplenishOrder>("WebGetReplenishOrder", { id });
}

export function saveReplenishOrder(rep: ReplenishOrder) {
  return servicePost<boolean>("WebSaveReplenishOrder", { rep });
}

export function setReplenishOrderFinished(id: number, status: boolean) {
  return servicePost<boolean>("WebSetReplenishOrderFinished", { id, status });
}

export function setReplenishOrderDeleted(id: number) {
  return servicePost<boolean>("WebSetReplenishOrderDeleted", { id });
}

export interface ReplenishKiosk {
  KioskID: number;
  OperatorID: number;
  Name: string;
  IsEmailing: boolean;
  ToEmail: string;
  IsActive: boolean;
  Deleted?: string | null;
  IncludeTestKiosks: boolean;
  IsActiveSubcontractor: boolean;
  SendFinishedEmailKiosk: boolean;
  SendFinishedEmailSubcontractor: boolean;
}

export function getAllReplenishKiosk(operatorId: number) {
  return servicePost<ReplenishKiosk[]>("WebGetAllReplenishKiosk", { operatorId });
}

export function getReplenishKiosk(id: number) {
  return servicePost<ReplenishKiosk>("WebGetReplenishKiosk", { id });
}

export function getReplenishKioskDefault(id: number, operatorId: number) {
  return servicePost<ReplenishKiosk>("WebGetReplenishKioskDefault", { id, operatorId });
}

export function saveReplenishKioskSetting(kiosk: ReplenishKiosk) {
  return servicePost<boolean>("WebSaveReplenishKioskSetting", { kiosk });
}
